import { api } from "../utlis/apiUtils"

export const createTicketOnIntercom = ({title, sender, messages})=>{
    return api.post("/create-intercom-ticket", {
        title,
        sender,
        description:"Conversation b/w ai and user \n "+ messages.map((message)=>`${message.sender}:`+message.text).join("\n") + "\n",
        messages: messages.map((message)=>`${message.sender}: `+message.text)
    })
}